import {createSocket} from '../utils';
import React, { Component } from "react"

const SocketContext = React.createContext<SocketIOClient.Socket>(undefined!)

class SocketComp extends Component<any, any> {
    private serverUrl = process.env.REACT_APP_CHATBOT_URL as string;
    private socket: SocketIOClient.Socket;
    private sessionId: string;

  constructor(props: any) {
      super(props);
      this.sessionId = props.sessionId as string;
      console.log("SocketIO create:", this.serverUrl, this.sessionId);
      this.socket = createSocket(this.serverUrl, this.sessionId, true);
  }

  render() {
    return (
      <SocketContext.Provider value={this.socket}>
        {this.props.children}
      </SocketContext.Provider>
    );
  }
}

export { SocketContext, SocketComp }